<template>
  <div
    id="app"
    :class="{
      'drawer-menu--open': showMenuDrawer,
      'drawer-menu--open--light': showMenuDrawerLight,
      'drawer-notifications--open': showNotificationsDrawer,
      'drawer-reports--open': showReportsDrawer,
    }"
  >
    <!-- <accordion-sidebar v-show="!$store.state.sidebar.locked" /> -->
    <div class="dashboard">
      <custom-header
        :loadingNotifications="loadingNotifications"
        :loadingReports="loadingReports"
        :notifications="countNotifications"
        :reports="countReports"
        v-if="isLogged"
        @openNotificationsDrawer="openNotificationsDrawer"
        @openReportsDrawer="openReportsDrawer"
        @closeKeyUpNotificationsDrawer="closeNotificationsDrawer"
        @closeKeyUpReportsDrawer="closeReportsDrawer"
        @loadNotifications="loadNotifications"
        @loadReports="loadReports"
        @openMenuDrawer="openMenuDrawer"
      ></custom-header>
      <transition name="component-fade" mode="out-in">
        <div class="main-content">
          <router-view />
        </div>
      </transition>
    </div>
    <menu-drawer
      v-show="!$store.state.sidebar.locked"
      @closeMenuDrawer="closeMenuDrawer"
      @mouseenterMenuDrawer="cancelMenuDrawerLightClose"
      @mouseleaveMenuDrawer="scheduleMenuDrawerLightClose"
    ></menu-drawer>
    <template v-if="isLogged">
      <notifications-drawer
        :notifications="notifications"
        @closeNotificationsDrawer="closeNotificationsDrawer"
        @reloadNotificationsDrawer="openNotificationsDrawer"
        @isLoadingNotificationsTrue="isLoadingNotificationsTrue"
        :isLoadingNotifications="isLoadingNotifications"
        :ref="notificationsDrawerRef"
      ></notifications-drawer>
      <reports-drawer
        :reports="reports"
        @closeReportsDrawer="closeReportsDrawer"
        @reloadReportsDrawer="reloadReportsDrawer"
        @isLoadingReportsTrue="isLoadingReportsTrue"
        :isLoadingReports="isLoadingReports"
        :ref="reportsDrawerRef"
      ></reports-drawer>
      <!-- Toaster dove verranno appesi i toast -->
      <b-toast
        v-for="job in jobs"
        :key="job.uid"
        v-model="job.visible"
        :id="`job-${job.uid}`"
        :no-auto-hide="true"
        solid
        :title="job.title"
        append-toast
        @hidden="onToastHidden(job)"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="mr-2">
            <div v-if="!job.ready">
              {{ job.messagePending }}
            </div>
            <div v-else>
              {{ job.messageReady }}
            </div>
          </div>

          <b-button
            v-if="job.type === 'report'"
            size="sm"
            variant="lisaweb"
            :disabled="!job.ready || job.loadingDownload"
            @click.stop="onDownloadClick(job)"
          >
            <span v-if="!job.ready && !job.loadingDownload"
              >In preparazione…</span
            >
            <span v-else-if="job.loadingDownload">Preparazione link…</span>
            <span v-else>Download</span>
          </b-button>

          <b-button
            v-else-if="job.type === 'massReduce'"
            size="sm"
            variant="lisaweb"
            :disabled="!job.ready"
            @click.stop="onMassReduceToastAction(job)"
          >
            <span v-if="!job.ready">In corso…</span>
            <span v-else>{{
              isOnJobPage(job) ? "Aggiorna elenco" : job.goLabel
            }}</span>
          </b-button>
        </div>
      </b-toast>
    </template>
    <div
      class="left-menu-trigger"
      v-if="isLogged && !$store.state.sidebar.locked"
      @mouseenter="scheduleMenuDrawerLightOpen"
      @mouseleave="cancelMenuDrawerLightOpen"
    ></div>
  </div>
</template>

<script>
// import { showSnackbar } from "@/utils/messages";
import NotificationsDrawer from "@/components/NotificationsDrawer.vue";
import ReportsDrawer from "@/components/ReportsDrawer.vue";
import CustomHeader from "@/components/CustomHeader.vue";
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import client from "@/repositories/api";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import MenuDrawer from "./components/MenuDrawer.vue";
import { keepModalHeight } from "@/utils/modalHeight";

// App\Models\MassReduce::FAILED — stato terminale di una chiusura massiva non riuscita.
const MASS_REDUCE_FAILED = 3;

export default {
  mixins: [DocumentsMixin],
  data() {
    return {
      showMenuDrawer: false,
      showMenuDrawerLight: false,
      menuDrawerLightOpenTimeout: null,
      menuDrawerLightCloseTimeout: null,
      showNotificationsDrawer: false,
      showReportsDrawer: false,
      loadingNotifications: false,
      loadingReports: false,
      isLoadingNotifications: false,
      isLoadingReports: false,
      countNotifications: 0,
      countReports: 0,
      notifications: [],
      reports: [],
      notificationsDrawerRef: "notificationDrawer",
      reportsDrawerRef: "reportDrawer",
      jobs: [],
      jobUid: 0,
    };
  },
  components: {
    CustomHeader,
    // AccordionSidebar,
    MenuDrawer,
    NotificationsDrawer,
    ReportsDrawer,
  },
  computed: {
    ...mapGetters("sidebar", ["isNavClose"]),
    ...mapGetters("auth", ["isLogged", "permissions"]),
    ...mapActions("tabs", { removeAllTabs: "removeAll" }),
  },
  methods: {
    isOnJobPage(job) {
      return this.$route && this.$route.name === job.routeName;
    },
    loadReports() {
      this.loadingReports = true;
      const Repo = RepositoryFactory.get("generated_report");
      Repo.index(
        `page=1&perPage=20&byReport&byDocument&sort[byAttribute]=created_at&dir[byAttribute]=desc`,
      )
        .then((response) => {
          this.countReports = response?.data?.data?.length;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.loadingReports = false;
        });
    },
    loadNotifications() {
      this.loadingNotifications = true;
      const Repo = RepositoryFactory.get("task");
      Repo.show_memo()
        .then((response) => {
          this.countNotifications = response?.data?.data?.length;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.loadingNotifications = false;
        });
    },
    isLoadingNotificationsTrue() {
      this.isLoadingNotifications = true;
    },
    isLoadingReportsTrue() {
      this.isLoadingReports = true;
    },
    keyUpFnNotification(e) {
      // ESC
      if (e.keyCode === 27) this.closeNotificationsDrawer();
    },
    keyUpFnReport(e) {
      // ESC
      if (e.keyCode === 27) this.closeReportsDrawer();
    },
    keyUpFn(e) {
      // ESC
      if (e.keyCode === 27) {
        this.closeMenuDrawer();
        this.closeNotificationsDrawer();
      }
    },
    openMenuDrawer() {
      this.cancelMenuDrawerLightOpen();
      this.cancelMenuDrawerLightClose();
      this.showMenuDrawerLight = false;
      this.showMenuDrawer = true;
      document.addEventListener("keyup", this.keyUpFn);
    },
    openNotificationsDrawer() {
      this.loadingNotifications = true;
      const Repo = RepositoryFactory.get("task");
      Repo.show_memo()
        .then((response) => {
          this.notifications = response?.data?.data;
          this.countNotifications = response?.data?.data?.length;
          this.showNotificationsDrawer = true;
          this.$refs[this.notificationsDrawerRef].$el.focus();
          document.addEventListener("keyup", this.keyUpFnNotification);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.loadingNotifications = false;
          this.isLoadingNotifications = false;
        });
    },
    reloadReportsDrawer() {
      this.isLoadingReports = true;
      this.loadingReports = true;
      const Repo = RepositoryFactory.get("generated_report");
      Repo.index(
        `page=1&perPage=20&byReport&byDocument&sort[byAttribute]=created_at&dir[byAttribute]=desc`,
      )
        .then((response) => {
          this.reports = response?.data?.data;
          this.countReports = response?.data?.data?.length;
          this.$refs[this.reportsDrawerRef].$el.focus();
          document.addEventListener("keyup", this.keyUpFnReport);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.loadingReports = false;
          this.isLoadingReports = false;
        });
    },
    openReportsDrawer() {
      this.loadingReports = true;
      const Repo = RepositoryFactory.get("generated_report");
      Repo.index(
        `page=1&perPage=20&byReport&byDocument&sort[byAttribute]=created_at&dir[byAttribute]=desc`,
      )
        .then((response) => {
          this.reports = response?.data?.data;
          this.countReports = response?.data?.data?.length;
          this.showReportsDrawer = true;
          this.$refs[this.reportsDrawerRef].$el.focus();
          document.addEventListener("keyup", this.keyUpFnReport);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.loadingReports = false;
          this.isLoadingReports = false;
        });
    },
    closeNotificationsDrawer() {
      if (!this.showNotificationsDrawer) return;
      this.showNotificationsDrawer = false;
      document.removeEventListener("keyup", this.keyUpFnNotification);
    },
    closeMenuDrawer() {
      if (!this.showMenuDrawer) return;
      this.showMenuDrawer = false;
      document.removeEventListener("keyup", this.keyUpFn);
    },
    scheduleMenuDrawerLightOpen() {
      if (this.showMenuDrawer || this.showMenuDrawerLight) return;

      this.cancelMenuDrawerLightOpen();

      this.menuDrawerLightOpenTimeout = setTimeout(() => {
        this.showMenuDrawerLight = true;
        this.menuDrawerLightOpenTimeout = null;
      }, 250);
    },
    cancelMenuDrawerLightOpen() {
      if (this.menuDrawerLightOpenTimeout) {
        clearTimeout(this.menuDrawerLightOpenTimeout);
        this.menuDrawerLightOpenTimeout = null;
      }
    },
    openMenuDrawerLight() {
      if (this.showMenuDrawer) return; // if the full drawer is open, do nothing
      this.cancelMenuDrawerLightClose();
      this.showMenuDrawerLight = true;
    },
    closeMenuDrawerLight() {
      if (this.showMenuDrawer) return;
      this.cancelMenuDrawerLightOpen();
      this.cancelMenuDrawerLightClose();
      this.showMenuDrawerLight = false;
    },
    cancelMenuDrawerLightClose() {
      if (this.menuDrawerLightCloseTimeout) {
        clearTimeout(this.menuDrawerLightCloseTimeout);
        this.menuDrawerLightCloseTimeout = null;
      }
    },
    scheduleMenuDrawerLightClose() {
      if (this.showMenuDrawer) return;
      this.cancelMenuDrawerLightClose();
      this.menuDrawerLightCloseTimeout = setTimeout(() => {
        this.showMenuDrawerLight = false;
        this.menuDrawerLightCloseTimeout = null;
      }, 80);
    },
    closeReportsDrawer() {
      if (!this.showReportsDrawer) return;
      this.showReportsDrawer = false;
      document.removeEventListener("keyup", this.keyUpFnReport);
    },
    preventF5(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    // Crea un nuovo toast + job e fa partire il polling
    createJob(id, label, format) {
      const job = {
        id,
        uid: ++this.jobUid,
        type: "report",
        title: label,
        messagePending: `Report ${format.toUpperCase()} in elaborazione`,
        messageReady: "Il file è pronto!",
        ready: false,
        downloadUrl: null,
        pollingTimer: null,
        pollingIntervalMs: 10000,
        loadingDownload: false,
        visible: true, // appena creato, il toast è visibile
      };
      this.jobs.push(job);
      this.startPolling(job);
    },
    createMassReduceJob(total, context = {}) {
      const entity = context.entity || "sospesi";
      const entityLabel = entity.charAt(0).toUpperCase() + entity.slice(1);
      const job = {
        id: null,
        uid: ++this.jobUid,
        type: "massReduce",
        title: `Chiusura massiva - ${entityLabel}`,
        messagePending: `Chiusura massiva in corso${
          total ? ` (${total} ${entity})` : ""
        }…`,
        messageReady: "Chiusura massiva completata.",
        routeName: context.routeName || "module.CONT.SOSP",
        reloadEvent: context.reloadEvent || "reloadDeferred",
        goLabel: context.goLabel || "Vai ai sospesi",
        ready: false,
        pollingTimer: null,
        pollingIntervalMs: 10000,
        visible: true,
      };
      this.jobs.push(job);

      return job;
    },
    onMassReduceStart({ payload, total, context } = {}) {
      if (!payload) return;
      const job = this.createMassReduceJob(total, context);
      RepositoryFactory.get("mass_reduce")
        .store(payload)
        .then((response) => {
          // jobResponse() del backend: {status, job, time}
          const id = response?.data?.job;
          if (id) {
            job.id = id;
            this.startPolling(job);
          } else {
            job.visible = false;
          }
        })
        .catch((error) => {
          job.visible = false;
          this.$showSnackbar({
            preset: "error",
            text: this.$getErrorMessage(error),
          });
        });
    },
    // Avvia il polling per un singolo job
    startPolling(job) {
      this.stopPolling(job);
      job.pollingTimer = setInterval(async () => {
        try {
          if (job.type === "massReduce") {
            await this.pollMassReduce(job);
          } else {
            await this.pollReport(job);
          }
        } catch (e) {
          console.error("Errore nel polling del job", job.id, e);
        }
      }, job.pollingIntervalMs);
    },
    async pollReport(job) {
      const { data } = await client.get(
        `/generated_reports?page=1&perPage=1&byReport&byDocument&byAttribute[id]=${job.id}`,
      );
      // adatta al formato reale
      if (data?.data?.[0]?.status_report?.value === 5) {
        job.document = data?.data?.[0]?.documents?.[0];
        job.ready = true;
        this.stopPolling(job);
      }
    },
    async pollMassReduce(job) {
      const { data } = await RepositoryFactory.get("mass_reduce").show(job.id);
      // Envelope standard delle risorse ({status, data}), con status e is_ready
      // serializzati come Enumerable: stessa forma letta da pollReport().
      const mr = data?.data;
      if (mr?.is_ready?.value !== "Y") return;
      job.ready = true;
      if (mr.status_massreduce?.value === MASS_REDUCE_FAILED) {
        const err = mr.result?.error || "operazione non riuscita";
        job.messageReady = `Chiusura massiva non riuscita: ${err}`;
      } else {
        const skipped = (mr.skipped || 0) + (mr.result?.skipped_zero || 0);
        job.messageReady =
          `Chiusura massiva completata: ${mr.processed} chiusi` +
          (skipped ? `, ${skipped} saltati` : "") +
          (mr.failed ? `, ${mr.failed} errori` : "") +
          ".";
      }
      this.stopPolling(job);
    },
    // Ferma il polling per un job
    stopPolling(job) {
      if (job.pollingTimer) {
        clearInterval(job.pollingTimer);
        job.pollingTimer = null;
      }
    },
    // Quando l'utente clicca il bottone Download
    onDownloadClick(job) {
      if (!job.ready || job.loadingDownload) return;
      if (!job?.document) {
        console.error("Errore nel recupero del link di download");
        this.$showSnackbar({
          preset: "error",
          text: "Siamo spiacenti, c'è stato un errore nel recuperare il file.",
        });
      }
      job.loadingDownload = true;
      this.downloadDocument(job.document);
      job.loadingDownload = false;
      // chiudo il toast impostando visible = false
      job.visible = false;
    },
    // Evento emesso quando il toast viene chiuso (X o hide())
    onToastHidden(job) {
      this.stopPolling(job);
      this.jobs = this.jobs.filter((j) => j !== job);
    },
    onToastReport(obj) {
      if (!obj?.id || !obj?.label || !obj?.format) return;
      this.createJob(obj.id, obj.label, obj.format);
    },
    onMassReduceToastAction(job) {
      if (!job.ready) return;
      job.visible = false;
      if (this.isOnJobPage(job)) {
        this.$root.$emit(job.reloadEvent);
      } else {
        this.$router.push({ name: job.routeName }).catch(() => {});
      }
    },
    onGridPlainTextCopy(e) {
      // When copying from a details-card grid, write only plain text so the
      // alternating row background-colors aren't carried into the HTML clipboard
      // (e.g. pasting into Word with "keep original formatting").
      const sel = window.getSelection();
      const text = sel && sel.toString();
      if (!text) return;
      let node = sel.anchorNode;
      if (node && node.nodeType !== 1) node = node.parentElement;
      if (node && node.closest && node.closest(".custom-grid-wrapper")) {
        e.clipboardData.setData("text/plain", text);
        e.preventDefault();
      }
    },
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapActions("queue", [/* "popQueue", "pushQueue", */ "emptyQueue"]),
    ...mapGetters("queue", ["getQueue"]),
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventF5);
  },
  mounted() {
    this.$root.$on("toastReport", this.onToastReport);
    this.$root.$on("massReduceStart", this.onMassReduceStart);
    document.addEventListener("copy", this.onGridPlainTextCopy);
    this.stopModalHeight = keepModalHeight(this.$root);
  },
  beforeDestroy() {
    this.$root.$off("toastReport", this.onToastReport);
    this.$root.$off("massReduceStart", this.onMassReduceStart);
    document.removeEventListener("copy", this.onGridPlainTextCopy);
    this.stopModalHeight?.();
    this.cancelMenuDrawerLightOpen();
    this.cancelMenuDrawerLightClose();
  },
};
</script>

<style lang="scss">
#app {
  font-family: var(--font-family);
  // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
  //   "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
  //   "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  height: 100vh;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.dashboard {
  flex: 1;
  margin-left: 0;
  transition: transform 0.2s linear;
  overflow-x: hidden;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.left-menu-trigger {
  position: fixed;
  left: 0;
  top: 0;
  width: 1px;
  height: 100dvh;
  background: var(--lisaweb);
  z-index: 9998;
}
.left-menu-trigger:after {
  position: absolute;
  top: 0;
  right: -4px;
  display: block;
  width: 4px;
  height: 100dvh;
  content: "";
  background: var(--lisaweb);
  box-shadow: 1px 0 0 0 var(--color-bg);
  pointer-events: none;
  touch-action: none;
  cursor: default;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
#app.drawer-menu--open .left-menu-trigger {
  z-index: 4;
}
</style>
